/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: BI Cloud (C) Copyright IBM Corp. 2018
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */
define([
	'../../lib/@waca/core-client/js/core-client/ui/core/View',
	'underscore',
	'react',
	'react-dom',
	'ca-ui-toolkit'
], function(View, _, React, ReactDOM, Toolkit) {

	const { ToggleSwitch } = Toolkit;

	/**
	 * Represents an item in a menu with a toggle button.
	 */
	var ItemWithToggle = View.extend({
		baseClass: 'toolbar',

		/**
		 * Creates a new menu item with a toggle.
		 *
		 * @param spec -
		 *            The menu item spec {label, eventHandler, group, enabled}
		 */
		init: function(spec) {
			_.extend(this, spec);
			ItemWithToggle.inherited('init', this, arguments);
		},

		/**
		 * Draws the ItemWithToggle
		 */
		render: function() {
			this.$el
				.empty()
				.addClass(this.baseClass + 'Icon ' + this.baseClass + 'Item ' + this.group);

			//TODO: Add prop validation
			/* eslint-disable react/prop-types */
			class ItemWithToggle extends React.Component {
				constructor(props) {
					super(props);
					this.state = _.clone(props.state);
					this.onToggleSwitch = props.onToggleSwitch;
				}
				render() {
					return (
						<ToggleSwitch
							label={this.props.label}
							onChange={() => {
								this.setState({ enabled: !this.state.enabled });
								this.onToggleSwitch(!this.state.enabled);
							}}
							checked={!!this.state.enabled}
							small={true}
							align='right'
						/>
					);
				}
			}
			/* eslint-enable react/prop-types */

			const menuItem = <button>
				<ItemWithToggle
					state={{ enabled: this.enabled }}
					onToggleSwitch={this.eventHandler.bind(this)}
					label={this.label}
				/>
			</button>;

			ReactDOM.render(menuItem, this.$el[0]);
			return this;
		}

	});

	return ItemWithToggle;
});
